import { type FC, type JSX } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import austriaFlag from '../../../../../../../public/images/flags/flag-austria.svg'
import belgiumFlag from '../../../../../../../public/images/flags/flag-belgium.svg'
import franceFlag from '../../../../../../../public/images/flags/flag-france.svg'
import germanyFlag from '../../../../../../../public/images/flags/flag-germany.svg'
import italyFlag from '../../../../../../../public/images/flags/flag-italy.svg'
import switzerlandFlag from '../../../../../../../public/images/flags/flag-switzerland.svg'
import { getTenantLocale } from '../../../../../../global-config'
import { StaticImage } from '../../../../../../image'
import { TENANT, tenantLanguagesConfig } from '../../../../../../tenant'
import { urlResolverGetHomepage } from '../../../../../../url-handling'
import { type FooterTenantLinks } from '../../../../config/PerTenantFooterConfiguration.type'

const tenantOrder = [
  TENANT.COM,
  TENANT.BE,
  TENANT.AT,
  TENANT.CH,
  TENANT.FR,
  TENANT.IT,
]

const countryNameByTenant: Record<TENANT, JSX.Element> = {
  [TENANT.AT]: <FormattedMessage id="footer.flag.austria.label" />,
  [TENANT.BE]: <FormattedMessage id="footer.flag.belgium.label" />,
  [TENANT.CH]: <FormattedMessage id="footer.flag.switzerland.label" />,
  [TENANT.COM]: <FormattedMessage id="footer.flag.germany.label" />,
  [TENANT.FR]: <FormattedMessage id="footer.flag.france.label" />,
  [TENANT.IT]: <FormattedMessage id="footer.flag.italy.label" />,
}

const assetsCountryFlagLogoMap: Record<TENANT, string> = {
  [TENANT.AT]: austriaFlag.src,
  [TENANT.BE]: belgiumFlag.src,
  [TENANT.CH]: switzerlandFlag.src,
  [TENANT.COM]: germanyFlag.src,
  [TENANT.FR]: franceFlag.src,
  [TENANT.IT]: italyFlag.src,
}

type FooterShopsProps = {
  tenantLinksItems: FooterTenantLinks
}

export const FooterShops: FC<FooterShopsProps> = ({ tenantLinksItems }) => {
  return (
    <ul className="flex shrink-0 flex-wrap justify-center gap-3 tablet:flex-nowrap tablet:justify-end">
      {tenantOrder.map((tenant) => (
        <li key={tenant}>
          <Link
            className="inline-flex items-center gap-2 no-underline"
            color="inherit"
            href={new URL(
              urlResolverGetHomepage({
                locale: getTenantLocale(
                  tenant,
                  tenantLanguagesConfig[tenant].defaultLanguage,
                ),
              }),
              tenantLinksItems[tenant],
            ).toString()}
          >
            <StaticImage
              alt=""
              height={20}
              src={assetsCountryFlagLogoMap[tenant]}
              width={30}
            />
            {countryNameByTenant[tenant]}
          </Link>
        </li>
      ))}
    </ul>
  )
}
